import { computed, DestroyRef, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PdfPreviewService {
	/** Registered viewer ids. The last one is selected unless an exclusive viewer exists. */
	public readonly $ids = signal<string[]>([]);
	private readonly $exclusiveId = signal<string | null>(null);

	public readonly $selectedId = computed(() => {
		return this.$exclusiveId() ?? this.$ids().at(-1) ?? null;
	});

	public generateId(destroyRef: DestroyRef, options?: { exclusive?: boolean }): string {
		const randomNumber = `${Math.random()}`.substring(2);
		const id = `pdf-preview-${Date.now()}-${randomNumber}`;

		this.$ids.update((ids) => [...ids, id]);

		if (options?.exclusive) {
			this.$exclusiveId.set(id);
		}

		destroyRef.onDestroy(() => {
			this.$ids.update((ids) => ids.filter((existingId) => existingId !== id));
			if (this.$exclusiveId() === id) {
				this.$exclusiveId.set(null);
			}
		});

		return id;
	}

	public selectId(id: string): void {
		if (this.$exclusiveId() && this.$exclusiveId() !== id) {
			return;
		}

		this.$ids.update((ids) => {
			if (ids.at(-1) === id) {
				return ids;
			}

			return [...ids.filter((existingId) => existingId !== id), id];
		});
	}
}
